<div
  *ngIf="configurationWithMetaData$ | async as configuration; else showLoadingPage"
  [ngClass]="hideConfiguration ? ' d-none' : ''">
  <dcp-configurator-header-messages
    *ngIf="configuration?.validation || (externalValidations?.length ?? 0) > 0"
    class="d-block"
    [class.udex-mt-24]="configuration?.validation || (externalValidations?.length ?? 0) > 0"
    [configuration]="configuration"
    [externalValidations]="externalValidations"></dcp-configurator-header-messages>
  <ng-container *ngIf="{value: (technicalGroupDisplay$ | async)} as technicalGroupDisplay">
    <ng-container *ngFor="let mergedGroup of getGroups(technicalGroupDisplay.value ?? false, configuration)">
      <ng-container *ngIf="!isGroupEmpty(mergedGroup)">
        <ng-container *ngIf="mergedGroup.groupType && isConflictGroupType(mergedGroup.groupType)">
          <cx-configurator-conflict-description [currentGroup]="mergedGroup"></cx-configurator-conflict-description>
        </ng-container>
        <div
          class="cps-config-group udex-p-24 udex-pb-32 udex-mt-20"
          libGroupSkip
          [groupSkipContent]="true"
          tabindex="0"
          [attr.aria-labelledby]="mergedGroup.description"
          [class.addon-group]="mergedGroup.name?.includes('_ADDONS')"
          [class.addon-group--scrollable]="
            mergedGroup.name?.includes('_ADDONS') &&
            (mergedGroup.attributes ? mergedGroup.attributes.length > 6 : false)
          ">
          <h5 class="eyebrow--m" [ngClass]="mergedGroup.validation?.length ? 'udex-mb-24' : 'udex-mb-32'">
            {{ mergedGroup.description }}
          </h5>
          <udex-message-strip
            *ngFor="let validation of mergedGroup.validation; let last = last"
            [ngClass]="last ? 'udex-mb-24' : 'udex-mb-8'"
            [design]="getFormattedSeverity(validation.severity)"
            hide-close-button
            status-type="Icon">
            <span class="body--s" style="vertical-align: middle" [innerHtml]="validation.description"></span>
          </udex-message-strip>
          <ng-container *ngIf="!isDialogActive(configuration); else ghostForm">
            <dcp-disable-loading-form>
              <cx-configurator-group
                [group]="mergedGroup"
                [owner]="configuration.owner"
                [isNavigationToGroupEnabled]="isNavigationToGroupEnabled(configuration)"></cx-configurator-group>
            </dcp-disable-loading-form>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="configuration?.owner?.type !== ownerType.CART_ENTRY">
      <div class="udex-pt-20">
        <udex-button size="Medium" class="udex-mb-20" (click)="deleteConfiguration()" design="Secondary"
          >{{ 'configurator.reset' | cxTranslate }}
        </udex-button>
        <br />
        <udex-button size="Medium" class="udex-mb-20 udex-mb-lg-0" (click)="bookmark()" design="Secondary"
          >{{ 'configurator.bookmark' | cxTranslate }}
        </udex-button>
      </div>
    </ng-container>
  </ng-container>
  <ng-template #ghostForm>
    <ng-container *ngFor="let number of [0, 1, 2]">
      <div class="cx-ghost-attribute">
        <div class="cx-ghost-header">
          <div class="cx-ghost-title ghost"></div>
          <div class="cx-ghost-icon ghost"></div>
        </div>
        <div class="cx-ghost-body">
          <div class="cx-ghost-text ghost"></div>
          <div class="cx-ghost-price ghost"></div>
        </div>
      </div>

      <div class="cx-ghost-attribute">
        <div class="cx-ghost-header">
          <div class="cx-ghost-title ghost"></div>
          <div class="cx-ghost-icon ghost"></div>
          <div class="cx-ghost-description-box">
            <div class="cx-ghost-description ghost"></div>
          </div>
        </div>
        <div class="cx-ghost-body">
          <div *ngFor="let number of [0, 1, 2]; let i = index" class="cx-ghost-radiobutton-value">
            <div class="cx-ghost-value-label-pair">
              <div class="cx-ghost-value-icon ghost"></div>
              <div class="cx-ghost-label ghost"></div>
            </div>
            <div class="cx-ghost-value-price ghost">
              <ng-container *ngIf="i !== 0">
                <div class="cx-ghost-price"></div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-template>
</div>
<ng-content></ng-content>
<ng-template #showLoadingPage>
  <div class="loading-page">
    <dcp-loading-page fullScreen *ngIf="!hideConfiguration" />
  </div>
</ng-template>
